import { render, staticRenderFns } from "./SelectStrategyImportFromFig.vue?vue&type=template&id=360bb647&scoped=true"
import script from "./SelectStrategyImportFromFig.vue?vue&type=script&lang=js"
export * from "./SelectStrategyImportFromFig.vue?vue&type=script&lang=js"
import style0 from "./SelectStrategyImportFromFig.vue?vue&type=style&index=0&id=360bb647&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360bb647",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('360bb647')) {
      api.createRecord('360bb647', component.options)
    } else {
      api.reload('360bb647', component.options)
    }
    module.hot.accept("./SelectStrategyImportFromFig.vue?vue&type=template&id=360bb647&scoped=true", function () {
      api.rerender('360bb647', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/SelectStrategyImportFromFig.vue"
export default component.exports